// ========= Slides ========== //
document.addEventListener('DOMContentLoaded', function () {
var elms = document.getElementsByClassName( 'splide' );

for ( var i = 0; i < elms.length; i++ ) {
  new Splide( elms[ i ] ).mount();
}
})

// ========= Place Holder image ========== //
const images = document.querySelectorAll('.video-placeholder .image-placeholder');
const playButton = document.querySelectorAll('.video-placeholder .play-button');
const iframes = document.querySelectorAll('.video-placeholder iframe');
playButton.forEach((image,index) => {
  image.addEventListener('click', () => {
    playButton[index].style.display = 'none';
    images[index].style.display = 'none';
    iframes[index].style.display = 'block';
  })
}) 

var intervalId = setInterval(function() {
  document.querySelectorAll("a").forEach(function(anchor) {
    let url = anchor.getAttribute("href");
    if (url == "/collections/all/products/qlarivia") {
      anchor.setAttribute("target", "_blank");
    }
  });
}, 100);
var intervalId = setInterval(function() {
  document.querySelectorAll("#search-results a").forEach(function(anchor) {
    let url = anchor.getAttribute("href");
    if (url == "/products/qlarivia?_pos=1&_psq=deu&_ss=e&_v=1.0") {
      anchor.setAttribute("target", "_blank");
    }
  });
}, 100);
